import {
  WAITLIST_AUDIENCE_ROLES,
  type WaitlistAudienceRole
} from '@algoacademy/backend/modules/notifications/waitlist/constants'
import { z } from 'zod'

export { WAITLIST_AUDIENCE_ROLES, type WaitlistAudienceRole }

const fullNameSegments = (value: string) =>
  value
    .trim()
    .split(/\s+/)
    .filter(s => s.length > 0)

export const waitlistSignupSchemaZ = z.object({
  audienceRole: z.enum(WAITLIST_AUDIENCE_ROLES, {
    message: 'Wybierz kategorię, która Cię opisuje'
  }),
  fullName: z
    .string()
    .trim()
    .min(1, { message: 'Podaj imię i nazwisko' })
    .max(160, { message: 'Maksymalnie 160 znaków' })
    .refine(v => fullNameSegments(v).length >= 2, {
      message: 'Podaj imię i nazwisko (imię oraz nazwisko)'
    }),
  email: z.string().trim().email({ message: 'Podaj poprawny adres email' }),
  phone: z
    .string()
    .trim()
    .max(30)
    .refine(v => v === '' || /^\+?[0-9 \-()]{6,20}$/.test(v), 'Niepoprawny numer telefonu'),
  consentWaitlist: z.boolean().refine(v => v === true, {
    message: 'Aby przesłać zgłoszenie, potrzebujemy zgody na kontakt w sprawie listy oczekujących'
  }),
  consentMarketingOffers: z.boolean()
})

export type WaitlistSignupFormData = z.infer<typeof waitlistSignupSchemaZ>

export const waitlistSignupDefaultValues: Partial<WaitlistSignupFormData> = {
  audienceRole: undefined,
  fullName: '',
  email: '',
  phone: '',
  consentWaitlist: false,
  consentMarketingOffers: false
}
